module.exports = __webpack_public_path__ + "img/analytic.cabdf4e1.svg";